import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'arraySome',
    standalone: false
})
export class ArraySomePipe implements PipeTransform {

  transform<T>(
    value: T[] | null | undefined,
    searchValue: any,
    property?: keyof T
  ): boolean {
    if (!Array.isArray(value)) {
      return false;
    }

    return value.some(item => {
      if (!property || typeof item !== 'object') {
          return item === searchValue;
      }
      return (item as any)[property] === searchValue;
    });
  }

}